import { Link } from "react-router-dom";
import { Package, MapPin, Globe, Clock, Construction } from "lucide-react";

const BG = "https://customer-assets.emergentagent.com/job_6768475f-24b1-4c42-955e-0ab1f153e4eb/artifacts/0eq19p42_IMG_1890.png";

export default function SpareParts() {
  return (
    <main
      className="relative min-h-screen"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.55) 45%, rgba(0,0,0,0.15) 100%), url(${BG})`,
        backgroundSize: 'cover, cover',
        backgroundPosition: 'center, center',
        backgroundAttachment: 'scroll, scroll',
        backgroundRepeat: 'no-repeat, no-repeat',
      }}
    >
      <section className="container mx-auto px-6 pt-20 pb-24">
        <div className="max-w-xl bg-white/10 backdrop-blur-md border border-white/20 ring-1 ring-black/20 p-8 shadow-2xl">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FBBF24] mb-4 flex items-center gap-2">
            <Construction className="w-3.5 h-3.5" /> Under Construction
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white leading-[0.95]">
            Spare parts — coming soon.
          </h1>

          <div data-testid="spare-parts-notice" className="mt-6 border-l-4 border-[#FBBF24] bg-white/10 p-5">
            <p className="text-white/90 leading-relaxed">
              This page is <span className="font-semibold text-white">under construction</span>. As a first-year business we don't currently sell spare parts to the public — but we're working towards stocking a good range down the track. In the meantime, here's where you can grab what you need.
            </p>
          </div>

          <p className="mt-7 text-sm font-mono uppercase tracking-[0.2em] text-[#4ADE80]">Need a part now?</p>

          <div className="mt-3 space-y-3">
            <div className="bg-white/10 border border-white/15 p-4">
              <div className="flex items-center gap-2 text-white font-semibold">
                <MapPin className="w-4 h-4 text-[#4ADE80]" /> In person
              </div>
              <p className="mt-1.5 text-sm text-white/85 leading-relaxed">
                <span className="font-semibold text-white">Whitsunday Caravan, Camping &amp; Trailer Centre</span> at Cannonvale carries a good range of stock.
              </p>
              <Link to="/local-services" data-testid="spare-parts-local-link" className="mt-1 inline-block text-sm font-semibold text-[#4ADE80] underline hover:text-white">
                See their details on Local Services →
              </Link>
            </div>

            <div className="bg-white/10 border border-white/15 p-4">
              <div className="flex items-center gap-2 text-white font-semibold">
                <Globe className="w-4 h-4 text-[#4ADE80]" /> Online
              </div>
              <p className="mt-1.5 text-sm text-white/85 leading-relaxed">
                We use <span className="font-semibold text-white">RV Parts Express</span> or <span className="font-semibold text-white">Camp Smart</span>. Orders usually arrive in Bowen in about a week.
              </p>
              <div className="mt-1.5 flex items-center gap-1.5 text-xs text-white/70">
                <Clock className="w-3.5 h-3.5" /> ~1 week delivery to Bowen
              </div>
            </div>
          </div>

          <Link
            to="/request"
            data-testid="spare-parts-request-btn"
            className="mt-7 inline-flex bg-[#16A34A] text-white px-6 py-3 font-semibold hover:bg-[#15803D] transition-colors"
          >
            Not sure what you need? Leave a request
          </Link>
        </div>
      </section>
    </main>
  );
}
